// extracted by mini-css-extract-plugin
export default {"appWrapper":"LayoutContentWrapper_appWrapper__uN0pS","contentWrapper":"LayoutContentWrapper_contentWrapper__sQgUI"};